/**
 * Redesign color + type constants, mirrored from styles/global.css so TS/JSX can
 * use the exact same literal values the reference design uses inline. Prefer the
 * CSS custom properties (var(--fx-*)) in stylesheets; use these in inline styles.
 */
export const C = {
  bg: '#fafaf7',
  card: '#ffffff',
  ink: '#16181d',
  muted: '#5c5e63',
  accent: '#2547e0',
  accentHover: '#1d38b4',
  accentLight: '#9db1f5',
  accentBg: '#eef1fd',
  border: '#e4e3dc',
  borderFaint: '#eeede6',
  dark: '#101214',
  dark2: '#16181d',
  darkInk: '#f2f2ee',
  darkMuted: '#a5abb2',
  darkBorder: '#26292e',
  danger: '#b4372e',
  // `faint` is the small-caption grey ON LIGHT surfaces. The comp used #8a8a82,
  // which is ~3.3:1 on the bone canvas (under WCAG AA for small text); this
  // darkened value clears 4.5:1 while staying clearly "faint". On DARK surfaces
  // use `faintDark` (#8a8a82 already passes AA on ink, and darkening it there
  // would fail instead).
  faint: '#6f6f68',
  faintDark: '#8a8a82',
} as const;

export const FONT = "'Archivo', system-ui, sans-serif";
export const MONO = "'Spline Sans Mono', monospace";

/** The shared page frame width + gutter used by every ported screen. */
export const SHELL: React.CSSProperties = {
  maxWidth: 1200,
  margin: '0 auto',
  padding: '0 40px',
};
